export const siteConfig = {
  name: "HostRight",
  // Update when shared SEO, layout, navigation, or structured data changes.
  seoLastModified: "2026-07-22",
  hostingLocations: [
    {
      code: "US",
      name: "United States",
      description: "A solid fit for visitors across North America.",
    },
    {
      code: "EU",
      name: "Europe",
      description: "A solid fit for visitors across Europe and nearby regions.",
    },
  ],
} as const;
